import { inject, injectable } from 'inversify'
import { endTypeVariant } from '@/services/domain/messages/types'
import type { EndType, MessageSendEndFormScheme } from '@/services/domain/messages/types'
import type { SelectFieldConfig, DateFieldConfig } from '@/services/forms/types'
import type {
  FormGroupConfigurationInterface,
  TypedFormBuilderInterface,
} from '@/services/forms/baseForm/typedFormBuilder/types'
import type { Translatable } from '@/services/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type ComposeScheduledInitFormData from '@/services/domain/compose/ComposeScheduledInitFormData'

@injectable()
export class EndFormGroupConfiguration implements FormGroupConfigurationInterface<MessageSendEndFormScheme> {
  constructor(
    @inject(SERVICE_TYPES.TranslateService) private readonly translateService: Translatable,
    @inject(SERVICE_TYPES.ComposeScheduledInitFormData)
    protected readonly composeScheduledInitFormData: ComposeScheduledInitFormData,
  ) {}

  public configure(builder: TypedFormBuilderInterface<MessageSendEndFormScheme>): void {
    const messageSendRepeatInitFormData = this.composeScheduledInitFormData.getMessageSendRepeatInitFormData()

    builder
      .property((t) => t.type)
      .control<SelectFieldConfig<EndType>>({
        fieldType: 'select',
        value: messageSendRepeatInitFormData.end.type,
        options: () =>
          endTypeVariant.map((t) => ({
            text: this.translateService.t(`composeEndTypes.${t}`),
            value: t,
          })),
      })

    builder
      .property((t) => t.smsSessions)
      .control({
        fieldType: 'number',
        value: messageSendRepeatInitFormData.end.smsSessions,
      })
    builder
      .property((t) => t.date)
      .control<DateFieldConfig>({
        fieldType: 'datepicker',
        value: messageSendRepeatInitFormData.end.date,
        min: new Date(),
      })
  }
}
